import React from "react";
import "./footer.scss";
import logo from "../../media/EONNA.webp";
import {Link} from "react-router-dom";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img className="gambar-logo" src={logo} alt="logo-Parkspring" />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Eonna BSD City</h2>
            <h3>
              Jl. Raya Pagedangan,Kel. Cijantra, Kec. Pagedangan, Kec.
              Tangerang, Kabupaten Tangerang, Banten 15335
            </h3>
            <h4>Contact us : +6281770998006 (Andi) </h4>
            <Link to="/privacy-policy">
              <div className="footer-contact">Privacy Policy</div>
            </Link>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">
        © Eonna BSD City
        <div className="powered">Powered by Linktown</div>
      </div>
    </div>
  );
};

export default footer;
